<template>
  <div>
    <h2>Integer search</h2>
    <v-card>
      <v-card-text>
        <span v-if="!integerResults">Searching...</span>
        <span v-if="integerResults && integerResults.length == 0"
          >No results found</span
        >
        <template v-if="integerResults && integerResults.length > 0">
          <div>{{ integerResults.length }} result(s)</div>
          <ol>
            <li v-for="(integerResult, index) in integerResults" :key="index">
              <span
                :class="
                  $route.params.searchValue == integerResult.fileMini.fileId
                    ? 'searchHighlight'
                    : ''
                "
              >
                <File :file="integerResult.fileMini" />
              </span>
              <template v-if="integerResult.fileMini.instructionDate"
                >, instructed:
                {{
                  integerResult.fileMini.instructionDate | formatDate
                }}</template
              >
              <template v-if="integerResult.billId.length > 0">
                , bill:
                <template v-for="billId in integerResult.billId">
                  <span :key="billId">
                    <span></span>
                    <span
                      :class="
                        $route.params.searchValue == billId
                          ? 'searchHighlight'
                          : ''
                      "
                    >
                      <Bill :id="billId" />
                    </span>
                  </span>
                </template>
              </template>
              <template v-if="integerResult.quoteId != 0">
                <span>, quote:</span>
                <span
                  :class="
                    $route.params.searchValue == integerResult.quoteId
                      ? 'searchHighlight'
                      : ''
                  "
                >
                  <Quote :quoteId="integerResult.quoteId" />
                </span>
              </template>
              <template v-if="integerResult.boxId != 0">
                <span>,</span>
                <span
                  :class="
                    $route.params.searchValue == integerResult.boxId
                      ? 'searchHighlight'
                      : ''
                  "
                >
                  box:
                  <Box :boxId="integerResult.boxId" />
                </span>
              </template>
              <template v-for="entityMini in integerResult.entityMini">
                <span :key="entityMini.entityId">
                  <span>,</span>
                  <span
                    :class="
                      $route.params.searchValue == entityMini.entityId
                        ? 'searchHighlight'
                        : ''
                    "
                  >
                    {{ entityMini.entityType.name }}:
                    <Entity :entity="entityMini" />
                  </span>
                </span>
              </template>
              <br />
              <br />
            </li>
          </ol>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import SEARCH_INTEGER from "@/graphql/search/SearchInteger";
import Box from "@/components/link/Box";
import Bill from "@/components/link/Bill";
import Entity from "@/components/link/Entity";
import File from "@/components/link/File";
import Quote from "@/components/link/Quote";
export default {
  name: "Integer",
  components: {
    Box,
    Bill,
    Entity,
    File,
    Quote
  },
  data() {
    return {
      integerResults: null
    };
  },
  methods: {
    async fetchIntegerResults() {
      this.integerResults = null;
      const response = await this.$apollo.query({
        query: SEARCH_INTEGER,
        variables: { value: Number(this.$route.params.searchValue) }
      });
      if (!response || !response.data || !response.data.searchInteger) {
        this.integerResults = [];
        return;
      }
      this.integerResults = response.data.searchInteger;
      if (this.integerResults.length == 1) {
        this.$router.push({
          name: "file",
          params: {
            id: this.integerResults[0].fileMini.fileId
          }
        });
      }
    }
  },
  watch: {
    "$route.params.searchValue": {
      immediate: true,
      handler() {
        this.fetchIntegerResults();
      }
    }
  }
};
</script>

<style>
.searchHighlight {
  background: #ffff99;
  padding: 2px;
}

.searchCount {
  float: right;
  text-align: right;
  font-size: 1.5em;
  font-weight: bold;
}
</style>
